import React from "react";
import './BMIQuiz.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">       
        <div className="footer-info">
        <p><strong>Sure Med Compliance &copy; {new Date().getFullYear()}</strong></p>
          <p>Phone: <a href="tel:(251)272-7117">(251) 272-7117</a></p> 
        </div>       
      </div>
    </footer>
  );
};

export default Footer;

